<!--  -->
<template>
 <div  class="pb100">
    <banner/>
    <crumbs/>
    <div class="containers">
      <type-screen modelType="exhibit" :menu-id="this.$route.query.columnId" @typeObj="selectType"/>
        <ul class="exhibitList">
            <li @click="gotodetail(item.id)" v-for="item in dataList" :key="item.id">
             <div class="imgbox">
                <img class="imgcover" :src="getImage(item.cover)" alt="">
             </div>
              <h2>{{item.title}}</h2>
            </li>
            <nodata v-show="dataList.length === 0"/>
        </ul>
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="params.limit"
        :pager-count="5"
        layout="prev, pager, next"
        :total="total"
        class="pagemodel1">
      </el-pagination>
    </div>
 </div>
</template>

<script>
// import typeScreen from '@/components/typescreen/index'
import {getExhibitList} from '@/api/exhibit/index'
import crumbs from '@/components/crumbs/index'
import banner from '@/components/banner/index'
import typeScreen from '@/components/typescreen/index'
import nodata from '@/components/nodata/index'
export default {
  name: 'exhibit',
  meta: {
    showHeader: true
  },
  components: {
    banner,
    crumbs,
    typeScreen,
    nodata
  },
  data () {
    return {
      params: {
        page: 1,
        limit: 12,
        menuId: '',
        type: ''
      },
      menuId: '',
      dataList: [],
      total: 111
    }
  },
  created () {
    this.menuId = this.$route.query.columnId
    this.params.menuId = this.$route.query.columnId
    this.getlist()
  },
  methods: {
    getlist () {
      getExhibitList(this.params).then(res => {
        console.log(res)
        this.dataList = res.data.data.rows
        this.total = res.data.data.total
      })
    },
    selectType (obj) {
      this.params.type = obj.type
      this.params.types = obj.customTypeId
      this.params.page = 1
      this.currentPage = 1
      this.getlist()
    },
    getImage (val) {
      if (val === undefined) {
        return require('@/assets/common/images/default.png')
      } else {
        return val
      }
    },
    gotodetail (id) {
      if (this.$route.query.subhomepage !== undefined) {
        this.$router.push({path: '/exhibitdetail', query: {id, columnId: this.menuId, subhomepage: this.$route.query.subhomepage}})
      } else {
        this.$router.push({path: '/exhibitdetail', query: {id, columnId: this.menuId}})
      }
    },
    handleCurrentChange (val) {
      this.params.page = val
      this.getlist()
    }
  },
  beforeDestroy () {

  }
}

</script>

<style lang='scss' scoped>
@import '../../assets/common/scss/exhibit.scss'
</style>



// WEBPACK FOOTER //
// src/view/exhibit/list.vue